// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BuyerDealComponent } from './buyer-deal/buyer-deal.component';
import { DealDocResolver } from '@services/resolvers/deal-doc.resolver';
import { DealResolver } from '@services/resolvers/deal.resolver';
import { UserResolver } from '@services/resolvers/user.resolver';

const routes: Routes = [
    {
        path: '',
        component: BuyerDealComponent,
        resolve: {
            deal: DealResolver,
            dealDocs: DealDocResolver,
            user: UserResolver,
        },
    },
    {
        path: ':docId',
        loadChildren: () => import('../buyer-doc-container/buyer-doc-routing.module').then((m) => m.BuyerDocRoutingModule),
        resolve: {
            deal: DealResolver,
            dealDocs: DealDocResolver,
        },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class BuyerDealRoutingModule {}
